<section class="section-pd register-form">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="trinka-title mb-0 text-center ">
                    <h1 class="mb-4">企業洽詢</h1>
                    <p>請與我們分享您的需求，我們的團隊將盡快與您聯繫。</p>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-7 col-md-7 dflex">
                <div class="c-card enterpriseFormCard">
                    <div class="form-wrapper" *ngIf="formSection">
                        <form [formGroup]="contactForm" (ngSubmit)="sendContactUsForm()">
                            <div class="row">
                                <div class="col-12">
                                    <h5 class="md-title md-title1 mt-0">個人資料</h5>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>姓名*</mat-label>
                                            <input matInput placeholder="" formControlName="contactFormName" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>電子郵件*</mat-label>
                                            <input matInput placeholder="" formControlName="contactFormEmail" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>聯絡電話*（含國際區碼）</mat-label>
                                            <input type="number" matInput placeholder="" formControlName="contactphoneNo" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>職稱*</mat-label>
                                            <input matInput placeholder="" formControlName="DesignationTypes" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <!-- <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>Nature of business*</mat-label>
                                            <input matInput placeholder="" formControlName="NatureBusinessType" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div> -->
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>機構/公司名稱*</mat-label>
                                            <input matInput placeholder="" formControlName="contactFormSubjects" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <h5 class="md-title md-title1">需求詳情</h5>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>使用者人數</mat-label>
                                            <input matInput placeholder="" formControlName="countUsers" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>每月文件數量/使用量</mat-label>
                                            <input matInput placeholder="" formControlName="monthlyCountVolume" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <h5 class="md-title">您對哪些功能或解決方案有興趣？<small class="d-block">(可複選)</small></h5>
                                </div>
                                <div class="col-sm-12 col-12">
                                    <div class="featuresBox mt-3">
                                        <ul>
                                            <li *ngFor="let feature of forIntegration">
                                              <mat-checkbox
                                                [checked]="isSelected('integrationFeatures', feature)"
                                                (change)="toggleFeature('integrationFeatures', feature, $event.checked)">
                                                {{ feature }}
                                              </mat-checkbox>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- <div class="col-sm-6 col-12">
                                    <div class="featuresBox">
                                        <h3>Bulk Licenses</h3>
                                        <ul>
                                            <li *ngFor="let feature of forBulkLicenses">
                                              <mat-checkbox
                                                [checked]="isSelected('bulkLicensesFeatures', feature)"
                                                (change)="toggleFeature('bulkLicensesFeatures', feature, $event.checked)">
                                                {{ feature }}
                                              </mat-checkbox>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-12">
                                    <div class="featuresBox">
                                        <h3>AI Reports</h3>
                                        <ul>
                                            <li *ngFor="let feature of forReportsOnly">
                                                <mat-checkbox
                                                  [checked]="isSelected('reportsFeatures', feature)"
                                                  (change)="toggleFeature('reportsFeatures', feature, $event.checked)">
                                                  {{ feature }}
                                                </mat-checkbox>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-12">
                                    <div class="featuresBox">
                                        <h3>Miscellanous</h3>
                                        <ul>
                                            <li *ngFor="let feature of forOthers">
                                                <mat-checkbox
                                                  [checked]="isSelected('miscellanousFeatures', feature)"
                                                  (change)="toggleFeature('miscellanousFeatures', feature, $event.checked)">
                                                  {{ feature }}
                                                </mat-checkbox>
                                            </li>
                                        </ul>
                                    </div>
                                </div> -->
                                <!-- <div class="col-md-12">
                                    <div class="form-group select-group">
                                        <mat-form-field>
                                            <mat-label>Inquiry For</mat-label>
                                            <mat-select formControlName="contactFormInquiryFor" multiple>
                                                <mat-option *ngFor="let inquiry of inquiryFor" [value]="inquiry">{{ inquiry }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div> -->
                                <div class="col-md-12">
                                    <div class="form-group textArea w-100" >
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>其他補充說明</mat-label>
                                            <textarea matInput formControlName="contactFormMessage"></textarea>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <input type="text" formControlName="website" style="display:none">
                            <div class="btn-group justify-content-center">
                                <button type="submit" class="filled-btn" [disabled]="isSubmitting">
                                    <div id="loading"></div>
                                    <span>提交</span>
                                </button>
                            </div>
                        </form>
                    </div>  
                    <div class="thank_section contact_us_form" *ngIf="thankSection" #thankSectionRef>
                        <div class="form-group">
                            <svg width="90px" height="90px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>checkmark-circle</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-102.000000, -1141.000000)" fill="#00ab48"> <path d="M124.393,1151.43 C124.393,1151.43 117.335,1163.73 117.213,1163.84 C116.81,1164.22 116.177,1164.2 115.8,1163.8 L111.228,1159.58 C110.85,1159.18 110.871,1158.54 111.274,1158.17 C111.677,1157.79 112.31,1157.81 112.688,1158.21 L116.266,1161.51 L122.661,1150.43 C122.937,1149.96 123.548,1149.79 124.027,1150.07 C124.505,1150.34 124.669,1150.96 124.393,1151.43 L124.393,1151.43 Z M118,1141 C109.164,1141 102,1148.16 102,1157 C102,1165.84 109.164,1173 118,1173 C126.836,1173 134,1165.84 134,1157 C134,1148.16 126.836,1141 118,1141 L118,1141 Z" id="checkmark-circle" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>
                            <h2>感謝您！</h2>
                            <p>我們會儘快和您聯絡。</p>
                        </div>
                    </div>
                </div>
                <p class="tnc-statement">提交此表單即表示您同意我們的 <a href="/termsofservices" class="text-link">使用條款</a> 與 <a href="/privacypolicy" class="text-link">隱私政策</a>. </p>
            </div>
            <div class="col-lg-5 col-md-5 dflex">
                <div class="c-card enterpriseFormContent list-wrapper-style-2">
                    <div class="enterpriseCard list-wrapper-content-2">
                        <h4>不是企業或機構用戶嗎？</h4>
                        <p>Trinka 高級方案為個人用戶及小型或成長型團隊提供進階寫作協助。</p>
                        <a href="/pricing" class="link-text">
                            探索 Trinka 高級方案
                            <img src="/assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                        </a>
                    </div>
                    <div class="enterpriseCard list-wrapper-content-2">
                        <h4>量身打造的功能與解決方案，滿足企業與機構的多元需求</h4>
                        <ul class="list-item">
                            <li>敏感資料管理，完整遵循資料隱私與安全規範</li>
                            <li>依需求客製功能與價格</li>
                            <li>無縫整合 API、SDK 與內部部署方案</li>
                            <li>獨家解決方案：學術誠信套件、離線桌面應用程式、使用分析與使用者管理、開立本地發票等</li>
                            <li>建立自有 AI 模型與應用程式，擁有您的智慧財產權</li>
                        </ul>
                    </div>
                    <div class="enterpriseCard list-wrapper-content-2">
                        <h4>全球頂尖機構、出版社與企業的首選</h4>
                        <ul class="clientLogos">
                            <li>
                                <img src="../../../assets/images/enterprise-form/ieee.png" alt="IEEE" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/royal-chemistry.png" alt="royal society of chemistry" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/cshl.png" alt="CSHL" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/indegene.png" alt="indegene" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/takeda.png" alt="takeda" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/cbua.png" alt="cbua" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/myrma.png" alt="My rma" />
                            </li>
                            <!-- <li>
                                <img src="../../../assets/images/enterprise-form/tata-fintech.png" alt="tata fintech" />
                            </li> -->
                            <li>
                                <img src="../../../assets/images/enterprise-form/jsu.png" alt="JSU" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/university-of-johannesburg.png" alt="university-of-johannesburg" />
                            </li>
                            <!-- <li>
                                <img src="../../../assets/images/enterprise-form/istanbul-univeristy.png" alt="istanbul univeristy" />
                            </li>
                            <li>
                                <img src="../../../assets/images/enterprise-form/indonesia-university.png" alt="indonesia university" />
                            </li> -->
                        </ul>
                    </div>
                    <div class="enterpriseCard list-wrapper-content-2">
                        <h4>找不到您需要的？</h4>
                        <a href="/contactus" class="link-text">
                            聯繫客服
                            <img src="/assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>